import moment from 'moment-timezone'
import omit from 'lodash/omit'

import bulkDeleteRedditPostSubmissions from '@/graphql/mutations/posts/bulkDeleteRedditPostSubmissions.gql'
import deleteRedditPostSubmission from '@/graphql/mutations/posts/deleteRedditPostSubmission.gql'
import duplicateRedditPost from '@/graphql/mutations/posts/duplicateRedditPost.gql'
import submitRedditSubmission from '@/graphql/mutations/posts/submitRedditSubmission.gql'
import updateRedditPostSubmissionPostAt from '@/graphql/mutations/posts/updateRedditPostSubmissionPostAt.gql'
import allRedditSubmissions from '@/graphql/queries/posts/allRedditSubmissions.gql'
import deleteRedditSubmission from '@/graphql/mutations/posts/deleteRedditSubmission.gql'
import cancelSubmissionAutoRemoval from '@/graphql/mutations/posts/cancelSubmissionAutoRemoval.gql'

export default {
  code: 'reddit',
  name: 'Reddit',
  icon: 'reddit',
  color: '#ff4500',
  accountNoun: 'Account',
  postNoun: 'Post',
  internalPostNoun: 'Post',
  mutations: {
    submitPost: submitRedditSubmission,
    submitPostVariables: (submission) => {
      return {
        submissionId: submission.id,
        platform: submission.platform.toLowerCase()
      }
    },
    deletePost: deleteRedditPostSubmission,
    deletePostVariables: (submission) => {
      return { submissionId: submission.id }
    },
    bulkDeletePosts: bulkDeleteRedditPostSubmissions,
    bulkDeletePostsVariables: (submissions) => {
      return { submissionIds: submissions.map((s) => s.id) }
    },
    reschedulePost: updateRedditPostSubmissionPostAt,
    reschedulePostVariables: (submission) => {
      return { id: submission.id }
    },
    duplicatePost: duplicateRedditPost,
    removeSubmissionFromPlatformMutation: deleteRedditSubmission,
    cancelAutoRemoveMutation: cancelSubmissionAutoRemoval
  },
  queries: {
    allSubmissions: allRedditSubmissions
  },
  posts: {
    getPost(post) {
      let gallery = null
      if (post.media && !post.gallery) {
        gallery = {
          id: null,
          galleryMediaSet: [
            {
              id: null,
              caption: '',
              outboundUrl: '',
              order: 0,
              media: omit(post.media, ['__typename'])
            }
          ]
        }
      } else if (post.gallery) {
        gallery = {
          id: null,
          galleryMediaSet: post.gallery.galleryMediaSet.map((item) => ({
            id: null,
            caption: item.caption,
            outboundUrl: item.outboundUrl,
            order: item.order,
            media: omit(item.media, ['__typename'])
          }))
        }
      }

      return {
        caption: post.title,
        text: buildText(post),
        gallery: gallery,
        postAt: moment(post.submissions[0].postAt).toDate()
      }
    }
  }
}

function buildText(post) {
  let result = ''
  if (post.title) {
    result += post.title + '\n\n'
  }
  if (post.content) {
    result += post.content + '\n\n'
  }
  if (post.link) {
    result += post.link
  }
  return result.trim()
}
